import React, { HTMLAttributes } from "react";
import classNames from "classnames";

export type DropdownContainerProps = HTMLAttributes<HTMLDivElement>;

export const DropdownContainer = (props: DropdownContainerProps) => {
  const { children, className, ...rest } = props;
  return (
    <div className={classNames("dropdown", className)} {...rest}>
      {React.Children.map(children, (child) => {
        return child;
      })}
    </div>
  );
};

export default DropdownContainer;
